import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import AdvancedPaymentEditView from 'src/sections/advanced-payments/view/advanced-payments-edit-view';

export default function AdvancedPaymentEditPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { employeeID, id } = params;

  return (
    <>
      <Helmet>
        <title> Update advanced payment</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.UPDATE_ADVANCED_PAYMENT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <AdvancedPaymentEditView id={id ?? ''} employeeID={employeeID ?? ''} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
